import firebase from "firebase";
import config from "../config";
import {mapState} from "vuex";

export default {
    data: () => ({
        messaging: null,
        subscribed: false,
        token: null
    }),
    computed: {},
    created() {
        if (Notification.permission === "granted") {
            this.subscribed = true;
            this.onPermissionGranted();
        }
    },
    methods: {
        onPermissionGranted() {
            if (!firebase.apps.length) {
                firebase.initializeApp(config.firebase);
                const messaging = firebase.messaging();
                messaging.getToken({vapidKey: config.vapidKey})
                    .then(token => {
                        this.token = token;
                        console.log(token);
                    })
            }
        },
        onPermissionDenied() {
            this.subscribed = false;
        },

        getNotificationPermission() {
            Notification
                .requestPermission()
                .then(permission => {
                    if (permission === "granted") {
                        this.onPermissionGranted()
                    } else {
                        this.onPermissionDenied()
                    }

                });

        }

    }
}

